
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/advice/[category]/[slug]/[articleId]",
      function () {
        return require("private-next-pages/advice/[category]/[slug]/[articleId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/advice/[category]/[slug]/[articleId]"])
      });
    }
  